import { Button, Input } from "antd";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import SearchIcon from "../../../assets/icons/SearchIcon";
import CustomTable from "../../../components/ui/CustomTable";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { countParPageSerialNumber } from "../../../utils/number";
import { addKeyInArray } from "../../../utils/utils";

export default function DisbursementDetails() {
  const [selectedData, setSelectedData] = useState<string[]>([]);
  const { page, limit, handlePagination, handleLimit } = useTable();

  const columns: ColumnsType<LeaveDataType> = [
    {
      title: "#SL",
      dataIndex: "index",
      align: "center",
      width: 50,
      render: (_: any, __: any, index: number) =>
        countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Transaction ID",
      dataIndex: "transactionId",
    },
    {
      title: "Name",
      dataIndex: "name",
    },
    {
      title: "Wallet Number",
      dataIndex: "walletNumber",
    },
    {
      title: "Month",
      dataIndex: "month",
      align: "center",
    },

    {
      title: "Status",
      align: "center",
      dataIndex: "status",
      render: (value: string) => {
        const displayValue = value;

        return (
          <span
            className={`px-2 py-1 rounded text-xs font-medium ${
              displayValue === "Request Success"
                ? "bg-green-100 text-green-600"
                : displayValue === "Request Pending"
                ? "bg-yellow-100 text-yellow-600"
                : "bg-gray-100 text-gray-600"
            }`}
          >
            {displayValue}
          </span>
        );
      },
    },
    {
      title: "Amount (BDT)",
      align: "center",
      dataIndex: "amount",
    },
  ];

  return (
    <>
      <SidebarLayout title="Disbursement Details">
        <CustomTable
          loading={false}
          limit={limit}
          page={page}
          columns={columns}
          total={100}
          dataSource={addKeyInArray(data)}
          handleLimit={handleLimit}
          handlePagination={handlePagination}
          rowSelection={{
            type: "checkbox",
            selectedRowKeys: selectedData,
            onChange: (key) => {
              setSelectedData(key as string[]);
            },
            getCheckboxProps: (record) => {
              return {
                disabled: record?.status === "invited",
              };
            },
            columnWidth: 40,
          }}
          filterSection={
            <>
              <div className="px-3 py-1 bg-violet-50 rounded-[100px] inline-flex justify-center items-center gap-2.5">
                <div className="justify-start text-blue-600 text-base font-medium font-['Inter'] leading-7">
                  Total Amount: 2546 BDT
                </div>
              </div>

              <Input suffix={<SearchIcon />} placeholder="Search by Id" />

              <Button
                className="middle-button"
                type="primary"
                //    icon={<AddIcon />}
              >
                Approve
              </Button>
            </>
          }
        />
      </SidebarLayout>
    </>
  );
}

interface LeaveDataType {
  key: string;
  transactionId: string;
  name: string;
  walletNumber: string;
  month: string;
  amount: number;
  status: string;
}

const data: LeaveDataType[] = [
  {
    key: "1",
    transactionId: "XYZ2541",
    name: "Esther Howard",
    walletNumber: "12345678901",
    month: "Jan, 2025",
    amount: 6546,
    status: "Request Pending",
  },
  {
    key: "2",
    transactionId: "XYZ2541",
    name: "Esther Howard",
    walletNumber: "12345678901",
    month: "Jan, 2025",
    amount: 6546,
    status: "Request Success",
  },
  {
    key: "3",
    transactionId: "XYZ2541",
    name: "Esther Howard",
    walletNumber: "12345678901",
    month: "Jan, 2025",
    amount: 6546,
    status: "Request Success",
  },

  {
    key: "4",
    transactionId: "XYZ2541",
    name: "Esther Howard",
    walletNumber: "12345678901",
    month: "Jan, 2025",
    amount: 6546,
    status: "Request Pending",
  },
];
